import Marquee from "react-fast-marquee";
import { LeafMark } from "@/components/LeafMark";

const ITEMS = [
  "Darjeeling First Flush",
  "Assam Golden Tips",
  "Blue Label Reserve",
  "Black Label Smoked",
  "Masala Chai",
  "Mint",
  "Rose",
  "Hibiscus",
  "Herbal Green",
  "Special Turmeric",
  "Laung Tulsi Special",
  "Ayurvedic",
];

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-white/5 bg-stone-950 py-7"
  >
    <Marquee speed={28} pauseOnHover gradient={false}>
      {ITEMS.map((name) => (
        <span key={name} className="mx-10 flex items-center gap-10">
          <span className="font-serif text-2xl italic tracking-tight text-stone-500 md:text-3xl">
            {name}
          </span>
          <LeafMark className="h-5 w-5 text-amber-600/50" strokeWidth={2} />
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
